<template>
  <div class="home">
    <div
      v-if="!loading"
      style="display: flex; align-item: center; justify-content: center;">
      <img
        alt="Vue logo"
        src="../assets/logo.png">
    </div>
    <v-progress-circular
      v-else
      :indeterminate="true"
      :rotate="0"
      :size="200"
      :value="0"
      :width="10"
      color="light-blue">
      Getting store info.
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false
    }
  }
}
</script>

<style lang="css" scoped>
img {
  max-width: 80%;
}
.home {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
</style>
